<template>
  <div class="big">
    <div class="container">
      <div class="searchbox">
        <div>
          <span>标签类别</span>
          <el-select
            v-model="label_type"
            placeholder="请选择"
            style="width:220px;margin-left:10px"
            @change="search"
          >
            <el-option
              label="全部"
              value=""
            ></el-option>
            <el-option
              v-for="item in labelTypeList"
              :key="item.label_type"
              :label="item.label_type_name"
              :value="item.label_type"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          type="primary"
          @click="openAddDia"
          style="width: 120px"
          :disabled="
                  module_id_array[0] ? !module_id_array.includes('1353') : false
                "
        >添加标签</el-button>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            label="标签名"
            prop="label_name"
          ></el-table-column>
          <el-table-column
            label="标签类别"
            prop="label_type_name"
          >
          </el-table-column>
          <el-table-column
            label="医生人数"
            prop="doctor_count"
          ></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toDetail(scope.row)"
                :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1356')
                          : false
                      "
              >详情</el-button>
              <el-button
                type="text"
                @click="editDia(scope.row)"
                :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1354')
                          : false
                      "
              >编辑</el-button>
              <el-button
                type="text"
                v-if="!scope.row.doctor_count"
                @click="delLabel(scope.row.label_id)"
                :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1355')
                          : false
                      "
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin:20px 0"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="addDia"
      width="400px"
      :title="title"
      :close-on-click-modal="false"
    >
      <div class="mydia">
        <div>
          <span class="title">
            <span style="color:red">*</span>
            <span>标签名</span>
          </span>
          <el-input
            v-model="addData.label_name"
            style="width:200px"
            maxlength="10"
          ></el-input>
        </div>
        <div style="margin:20px 0">
          <span class="title">
            <span style="color:red">*</span>
            <span>标签类别</span>
          </span>
          <el-select
            v-model="addData.label_type"
            placeholder="请选择"
            style="width:200px"
            :disabled="title=='编辑标签'"
          >
            <el-option
              v-for="item in labelTypeList"
              :key="item.label_type"
              :label="item.label_type_name"
              :value="item.label_type"
            >
            </el-option>
          </el-select>
        </div>
        <div class="imgbox">
          <span class="title">
            图标
          </span>
          <div>
            <div class="uploadimg">
              <el-upload
                name="image"
                accept=".png,.jpeg,.jpg"
                :action="uploadUrl"
                :data="uploadExtraData"
                :headers="uploadHeaders"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="addData.label_img_str"
                  :src="addData.label_img_str"
                  class="avatar"
                />
                <div
                  v-else
                  class="uploader-icon"
                >
                  <div>
                    <i
                      class="el-icon-plus"
                      style="font-size: 16px"
                    ></i>
                  </div>
                  <el-button
                    type="text"
                    size="medium"
                    style="font-size: 14px"
                  >添加图片</el-button>
                  <div style="color: #b0babc; font-size: 12px">
                    支持jpg、png、jpeg格式
                  </div>
                </div>
                <el-button
                  v-if="addData.label_img_str"
                  type="text"
                  icon="el-icon-delete"
                  class="del_img"
                  @click="delImg"
                ></el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div style="text-align:center;margin:30px 0 10px">
          <el-button
            type="primary"
            size="medium"
            style="width: 92px"
            @click="sumbit"
          >提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import constant from '../../../service/common/constant';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      label_type: '',
      uploadExtraData: {
        img_type: 1,
        suffix: '.jpg'
      },
      labelTypeList: [],
      addDia: false,
      title: '添加标签',
      addData: {
        label_name: '',
        label_type: '',
        label_img: '',
        label_img_str: ''
      },
      doctorId: '',
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取医生标签列表
    getDoctorLabelList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        type: 2
      };
      this.axios.post('platform/Admin/getLabelType', data).then((res) => {
        if (res.code == 0) {
          this.labelTypeList = res.data.list;
        }
      });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        label_type: this.label_type
      };
      this.axios
        .post('platform/Doctor/getDoctorLabelList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    openAddDia() {
      this.title = '添加标签';
      this.addData = {
        label_name: '',
        label_type: '',
        label_img: '',
        label_img_str: ''
      };
      this.addDia = true;
    },
    editDia(row) {
      this.title = '编辑标签';
      this.addData = {
        label_name: row.label_name,
        label_type: row.label_type,
        label_img: row.label_img,
        label_img_str: row.label_img_str,
        label_id: row.label_id
      };
      this.addDia = true;
    },
    //删除图片
    delImg(event) {
      event.stopPropagation();
      this.addData.label_img = '';
      this.addData.label_img_str = '';
    },
    //提交
    sumbit() {
      if (!this.addData.label_name || !this.addData.label_type) {
        this.$message.error('请完善标签信息!');
        return false;
      }
      let data = this.addData;
      let url = 'platform/Doctor/addDoctorLabel';
      if (this.title == '编辑标签') {
        url = 'platform/Doctor/updateDoctorLabel';
      }
      this.axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.addDia = false;
          this.getList();
        }
      });
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 0) {
        this.addData.label_img = res.data.pic;
        this.addData.label_img_str = res.data.path;
      }
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadExtraData.img_type = 4;
      this.uploadHeaders.timestamp = Date.now();
      return isSupportType;
    },
    //详情
    toDetail(row) {
      this.$router.push({
        path: 'doctorlabeldetail',
        query: {
          label_id: row.label_id,
          label_name: row.label_name,
          label_type_name: row.label_type_name
        }
      });
    },
    //删除
    delLabel(label_id) {
      this.$confirm('确定删除当前标签吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Doctor/deleteDoctorLabel', { label_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                if (!(this.tableData.length - 1) % this.pagesize) {
                  this.currentPage =
                    this.currentPage == 1 ? 1 : this.currentPage - 1;
                }
                this.getList();
              }
            });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getDoctorLabelList();
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.imgbox {
  display: flex;
  box-sizing: border-box;
  text-align: center;
}
.uploadimg {
  width: 120px;
  height: 120px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;
  position: relative;
  .avatar {
    width: 120px;
    height: 120px;
  }
  .uploader-icon {
    padding-top: 10px;
    line-height: 20px;
    color: #669961;
  }
  .del_img {
    position: absolute;
    top: 1px;
    font-size: 22px;
    color: red;
    right: 5px;
  }
}
.mydia {
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
  .title {
    display: inline-block;
    width: 90px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>